import { TooltipProps } from '@mui/material';
import React, { CSSProperties } from 'react';

export interface InteractiveTooltipProps {
  /**
   * Block scroll if tooltip is open
   */
  blockScroll?: boolean;
  /**
   * The component used as the tooltip target
   */
  Trigger: React.JSX.Element;
  /**
   * The component used as the tooltips content to display
   */
  Contents: React.JSX.Element | null;
  /**
   * Setting the arrow of the tooltip
   */
  isWithArrow?: boolean;
  /**
   * Allowing an external controlled open state for the tooltip
   */
  overrideIsOpen?: boolean;
  /**
   * Setting the disablePortal for correct positioning
   */
  isThroughPortal?: boolean;
  /**
   * Setting the tooltips enter/exit delays in ms
   */
  tooltipDelay?: TooltipDelay | number;
  /**
   * Modifier: Setting the axes offsets
   */
  tooltipOffsets?: TooltipOffsets;
  /**
   * Modifier: Setting the flipping overflow threshold
   */
  tooltipPreventOverflow?: number;
  /**
   * Custom component styling for the tooltip
   ** Supporting: root, tooltip and arrow
   */
  componentsSx?: TooltipComponentsSx;
  /**
   * The targeted placement of the tooltip
   ** Placement changes according to position and Modifiers
   ** default: 'top'
   */
  targetPlacement?: TooltipProps['placement'];
  /**
   * Allowing the setting of an external controlled open state for the tooltip
   */
  setOverrideIsOpen?: (isOpen: boolean) => void;
}

export interface TooltipOffsets {
  y?: number;
  x?: number;
}

export interface TooltipComponentsSx {
  tooltip?: CSSProperties & { [key: string]: any };
  arrow?: CSSProperties & { [key: string]: any };
  root?: CSSProperties & { [key: string]: any };
}
export interface TooltipDelay {
  enter?: number;
  leave?: number;
}

export const tooltipDefaults: Partial<InteractiveTooltipProps> = {
  tooltipDelay: 300,
  isThroughPortal: false,
  tooltipOffsets: { y: 0, x: 0 } as TooltipOffsets,
  targetPlacement: 'top' as TooltipProps['placement'],
  componentsSx: {} as Partial<TooltipComponentsSx>,
  tooltipPreventOverflow: 8,
};
